import { render, staticRenderFns } from "./GridSystem.vue?vue&type=template&id=82e605a4&scoped=true&"
import script from "./GridSystem.vue?vue&type=script&lang=js&"
export * from "./GridSystem.vue?vue&type=script&lang=js&"
import style0 from "./GridSystem.vue?vue&type=style&index=0&id=82e605a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e605a4",
  null
  
)

export default component.exports